import { render, staticRenderFns } from "./cardTreeSkeleton.vue?vue&type=template&id=322887fe&scoped=true"
import script from "./cardTreeSkeleton.vue?vue&type=script&lang=js"
export * from "./cardTreeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./cardTreeSkeleton.vue?vue&type=style&index=0&id=322887fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322887fe",
  null
  
)

export default component.exports